import { Component, OnInit, Input, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { SharedService } from '@services/shared.service';
import { ApiTransactionService } from '@services/api-transaction.service';

import { NewTransactionPointsModel } from '@models/TransactionModel';

import { ModalFormBase } from '@shared/modal-base.component';

import { SmartListTransactionItem } from '@components/smart-list/GenericSmartList';
import { VendorStoreModel } from '@models/VendorModel';
import { Country } from '@shared/models/Enums';
import { SessionModel } from '@shared/models/SessionModel';
import { SessionManager } from '@services/session-manager';


@Component({
    selector: 'app-send-givi-modal',
    templateUrl: './send-givi-modal.component.html',
    styleUrls: ['./send-givi-modal.component.scss']
})
export class SendGiviModalComponent extends ModalFormBase<NewTransactionPointsModel> implements OnInit {

    @Input() givi: SmartListTransactionItem;
    @Input() isButton = false;


    @ViewChild('sendGiviModal', { static: true }) modal: TemplateRef<any>;

    // form
    formGroup: UntypedFormGroup;

    givilink: string;
    linkCopied = false;

    vendorStores: VendorStoreModel[] = [];

    session: SessionModel; 

    constructor(
        public sharedService: SharedService,
        public modalService: NgbModal,
        private apiTransactionService: ApiTransactionService) {
        super(modalService);
    }

    ngOnInit(): void {

        this.session = SessionManager.getSession(true);
    }

    onOpen() {

        this.vendorStores = this.givi.productStores?.filter(x => x.deletedAt == null);

        const code = `GV-${this.givi.id.toString().padStart(5, '0')}-${this.givi.customerOwnerId}`;
        let hash = window.btoa(code);

        // Remove the = symbol
        hash = hash.replace(/[=]/g, '');

        let text = `comercio=${this.givi.vendorName}`;
        // Remove the % symbol
        text = text.replace(/[%]/g, '');
        // Replace the spaces
        text = text.replace(/\s/g, '+');

        this.givilink = `${this.apiTransactionService.siteUrl}/tg/${this.session?.user?.country}/${hash}?${text}`;
        this.linkCopied = false;

        super.open(this.modal, {
            backdrop: 'static', keyboard: false,
            windowClass: 'modal-dialog-end modal-content-full'
        });
    }

    onClose() {

        super.close();
    }

    onCopyLink() {

        const copyText: any = document.getElementById('givi-link');

        copyText.focus();
        copyText.select();

        document.execCommand('Copy');

        this.linkCopied = true;

        setTimeout(() => { this.linkCopied = false }, 2000);
    }
}
